import { Injectable, inject } from '@angular/core';
import { Employee } from '@entity/employee';
import { TreeNode } from 'primeng/api';
import { Employment } from '@entity/employment';
import { EmployeeService } from '@service/employee.service';
import { AnyValue } from '@shared/table/table.types';
import { TreeTableCrudService } from '@shared/table/tree-table-crud.service';

@Injectable()
export class EmployeesTreeTableService extends TreeTableCrudService<Employee> {
  protected readonly entityService = inject(EmployeeService);

  protected toTreeNode(employee: Employee): TreeNode {
    return {
      data: {
        ...employee,
        employments: null,
      },
      children: employee.employments.map((employment) => ({
        data: {
          ...employment,
        },
      })),
    };
  }

  protected toEntity(treeNode: TreeNode): Employee {
    return {
      ...treeNode.data,
      employments: treeNode.children?.map(
        (employment: AnyValue) =>
          ({
            ...employment.data,
          }) as Employment
      ),
    } as Employee;
  }

  protected getId(employee: Employee): string {
    return employee.employeeId;
  }

  createEntry(tree: TreeNode[], parent?: TreeNode): TreeNode {
    if (!parent) {
      const employeeId = this.getNextId(tree, 'employeeId');
      return {
        data: {
          employeeId,
        },
        expanded: true,
        children: [
          {
            data: {
              employmentId: 1,
            },
          },
        ],
      };
    } else {
      return {
        data: {
          employmentId: this.getNextId(parent.children ?? [], 'employmentId'),
        },
        children: [],
      };
    }
  }
}
